import React from 'react';

export const FooterAbout: React.FC = () => {
  return (
    <div className="flex flex-col gap-6">
      {/* Heading */}
      <h3 className="text-[#888883] text-[15px] font-bold leading-[21px] tracking-[0.15px]">
        About ALYZE
      </h3>

      {/* Content */}
      <div className="text-[#888883] text-[15px] font-normal leading-[21px] tracking-[0.15px] space-y-4">
        <p>
          <span className="font-bold">The ALYZE Club</span> — the world's most comprehensive health club launching first in UT — will release official membership pricing at the end of February.
        </p>

        <p>
          <span className="font-bold">The ALYZE+ App</span>, including updated pricing, is scheduled for nationwide launch in 2026. The platform is designed to support advanced health testing — including bloodwork, epidemiology tracking, and biomarker analysis — alongside fully personalized health solutions such as custom supplements, wellness technology, and precision care programs.
        </p>

        <p>
          We also want to clarify the meaning behind <span className="font-bold">"ALYZE."</span> Within the ALYZE Club ecosystem, the name represents how we deliver guaranteed transformation — both inside and out:
        </p>

        <ul className="list-none pl-6 space-y-2">
          <li>• We <span className="font-bold">anALYZE</span> your health data</li>
          <li>• We <span className="font-bold">personALYZE</span> your wellness plan</li>
          <li>• We <span className="font-bold">revitALYZE</span> your life</li>
        </ul>

        <p>
          <span className="font-bold">ALYZE is more than a name</span> — it's the methodology powering measurable, lifelong health optimization.
        </p>
      </div>
    </div>
  );
};
